import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8ac2e4e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "table-chip"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "data-segment": 1,
  class: "pi pi-ellipsis-v"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/store/auth/login";
import { useShopsStore } from "@/store/dictionaries/shops";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Menu from "primevue/menu";
import UsersHistoryDialog from "@/widgets/dialogs/UsersHistoryDialog.vue";
import DeleteConfirmDialog from "@/shared/dialogs/DeleteConfirmDialog.vue";

import { convertDateFromUTC } from "@/services/utils/DateParser";
import { getUserFullName } from "@/services/utils/Names";
import { rootGetters } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShopsTable',
  props: {
    shops: {},
    isActiveFirst: { type: Boolean },
    isLoading: { type: Boolean },
    rowsCount: {}
  },
  emits: ["sortTable", "updateTable"],
  setup(__props: any, { emit: __emit }) {


const emits = __emit;
const router = useRouter();
const store = useShopsStore();
const authStore = useAuthStore();

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["history:edit"], ["history:read"]);
});

let modifiedId = ref(0);
const confirmVisible = ref({
  history: false,
  delete: false,
});
const blockedButtonDelete = ref(false);
const menu = ref();
const items = ref([
  {
    label: "История действий",
    icon: "pi pi-history",
    checkDenied: true,
    archive: "both",
    command: () => {
      confirmVisible.value.history = true;
    },
  },
  {
    label: "Редактировать",
    icon: "pi pi-pencil",
    archive: "no_archive",
    command: () => {
      router.push({ name: "shop", params: { id: modifiedId.value } });
    },
  },
  {
    label: "Удалить",
    icon: "pi pi-trash",
    archive: "both",
    command: () => {
      confirmVisible.value.delete = true;
    },
  },
]);

const filteredItems = computed(() => {
  return items.value.filter((item) => !(item.checkDenied && isDenied.value));
});

const toggle = (elemId: number, event: any) => {
  modifiedId.value = elemId;
  menu.value.toggle(event);
};

const sortTable = (event: any) => {
  let orderField = "";
  if (event.sortField)
    orderField = event.sortOrder > 0 ? event.sortField : `-${event.sortField}`;
  emits("sortTable", orderField);
};

const deleteShop = () => {
  blockedButtonDelete.value = true;
  store
    .deleteShop(modifiedId.value)
    .finally(() => {
      emits("updateTable");
      blockedButtonDelete.value = false;
      confirmVisible.value.delete = false;
    })
    .catch((err) => {
      if (err.response && err.response.status == 400)
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
    });
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DataTable), {
      value: _ctx.shops,
      class: _normalizeClass([[
      _ctx.shops && _ctx.shops.length == 0 ? 'empty-table' : '',
      _ctx.isActiveFirst ? 'active-first' : '',
    ], "scroll-table-y main-table scrollbar-custom"]),
      stripedRows: "",
      onSort: sortTable,
      removableSort: "",
      scrollable: "",
      loading: _ctx.isLoading,
      dataKey: "id",
      columnResizeMode: "expand"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          field: "number",
          header: "№",
          style: {"min-width":"44px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_ctx.rowsCount + slotProps.index + 1), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "name",
          header: "Название магазина",
          sortable: ""
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(_component_RouterLink, {
              to: { name: 'shop', params: { id: slotProps.data.id } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(slotProps.data.shop_name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "short_name",
          header: "Короткое название"
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.data.shop_short_name), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "shop_inn",
          header: "ИНН"
        }),
        _createVNode(_unref(Column), {
          field: "shop_pk",
          header: "Хэш ИНН"
        }),
        _createVNode(_unref(Column), {
          field: "shop_category",
          header: "Категория"
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.shop_category)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(slotProps.data.shop_category), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, "-"))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "has_data_from_providers",
          header: "Данные от провайдеров",
          style: {"min-width":"120px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.data.has_data_from_providers ? "Да" : "Нет"), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "cuser",
          header: "Автор",
          sortable: ""
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(getUserFullName)(slotProps.data.cuser)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "ctime",
          header: "Дата создания",
          sortable: "",
          style: {"min-width":"153px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotProps.data.ctime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "mtime",
          header: "Дата обновления",
          sortable: "",
          style: {"min-width":"173px","max-width":"173px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotProps.data.mtime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          frozen: "",
          alignFrozen: "right"
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("div", {
              onClick: (event) => toggle(slotProps.data.id, event),
              "aria-haspopup": "true",
              "aria-controls": "overlay_menu",
              class: "button-menu"
            }, _hoisted_5, 8, _hoisted_3)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "class", "loading"]),
    _createVNode(_unref(Menu), {
      ref_key: "menu",
      ref: menu,
      id: "overlay_menu",
      model: filteredItems.value,
      popup: true
    }, null, 8, ["model"]),
    _createVNode(DeleteConfirmDialog, {
      "deleted-name": "магазин",
      visible: confirmVisible.value.delete,
      blocked: blockedButtonDelete.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (confirmVisible.value.delete = false)),
      onDelete: deleteShop
    }, null, 8, ["visible", "blocked"]),
    _createVNode(UsersHistoryDialog, {
      entity: "shops",
      object_id: _unref(modifiedId),
      visible: confirmVisible.value.history,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (confirmVisible.value.history = false))
    }, null, 8, ["object_id", "visible"])
  ], 64))
}
}

})